// extracted by mini-css-extract-plugin
export default {"pillButtonPageStandFirst":"PillButtonPage_pillButtonPageStandFirst__U7AXH"};